var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10L14.75 10ZM2.75 10C2.75 9.58579 2.41421 9.25 2 9.25C1.58579 9.25 1.25 9.58579 1.25 10L2.75 10ZM13.25 10L13.25 12L14.75 12L14.75 10L13.25 10ZM12 13.25L4 13.25L4 14.75L12 14.75L12 13.25ZM2.75 12L2.75 10L1.25 10L1.25 12L2.75 12ZM4 13.25C3.30964 13.25 2.75 12.6904 2.75 12L1.25 12C1.25 13.5188 2.48122 14.75 4 14.75L4 13.25ZM13.25 12C13.25 12.6904 12.6904 13.25 12 13.25L12 14.75C13.5188 14.75 14.75 13.5188 14.75 12L13.25 12Z",
    fill: "#1554FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10C7.25 10.4142 7.58579 10.75 8 10.75C8.41421 10.75 8.75 10.4142 8.75 10L7.25 10ZM8 2L8.53033 1.46967C8.23744 1.17678 7.76256 1.17678 7.46967 1.46967L8 2ZM4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033C4.76256 5.82322 5.23744 5.82322 5.53033 5.53033L4.46967 4.46967ZM10.4697 5.53033C10.7626 5.82322 11.2374 5.82322 11.5303 5.53033C11.8232 5.23744 11.8232 4.76256 11.5303 4.46967L10.4697 5.53033ZM8.75 10L8.75 2L7.25 2L7.25 10L8.75 10ZM7.46967 1.46967L4.46967 4.46967L5.53033 5.53033L8.53033 2.53033L7.46967 1.46967ZM7.46967 2.53033L10.4697 5.53033L11.5303 4.46967L8.53033 1.46967L7.46967 2.53033Z",
    fill: "#1554FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.98ff8612b6659709d2623257cf6bf41c.svg";
export { ForwardRef as ReactComponent };